module.exports = __webpack_public_path__ + "static/media/bg.f66a1ce4.png";